// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * ALMA Chatbot API
 * API to manage Alma chatbot interactions.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface MainFeedbackRequest
 */
export interface MainFeedbackRequest {
  /**
   *
   * @type {string}
   * @memberof MainFeedbackRequest
   */
  answer?: string;
  /**
   *
   * @type {string}
   * @memberof MainFeedbackRequest
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof MainFeedbackRequest
   */
  question?: string;
  /**
   *
   * @type {string}
   * @memberof MainFeedbackRequest
   */
  rating?: string;
  /**
   *
   * @type {string}
   * @memberof MainFeedbackRequest
   */
  timestamp?: string;
}

/**
 * Check if a given object implements the MainFeedbackRequest interface.
 */
export function instanceOfMainFeedbackRequest(
  value: object,
): value is MainFeedbackRequest {
  return true;
}

export function MainFeedbackRequestFromJSON(json: any): MainFeedbackRequest {
  return MainFeedbackRequestFromJSONTyped(json, false);
}

export function MainFeedbackRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): MainFeedbackRequest {
  if (json == null) {
    return json;
  }
  return {
    answer: json['answer'] == null ? undefined : json['answer'],
    description: json['description'] == null ? undefined : json['description'],
    question: json['question'] == null ? undefined : json['question'],
    rating: json['rating'] == null ? undefined : json['rating'],
    timestamp: json['timestamp'] == null ? undefined : json['timestamp'],
  };
}

export function MainFeedbackRequestToJSON(json: any): MainFeedbackRequest {
  return MainFeedbackRequestToJSONTyped(json, false);
}

export function MainFeedbackRequestToJSONTyped(
  value?: MainFeedbackRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    answer: value['answer'],
    description: value['description'],
    question: value['question'],
    rating: value['rating'],
    timestamp: value['timestamp'],
  };
}
